<template>
    <div class="gradeContent">
        <div class="gradeMain">
            <div class="gradeTle"><i class="el-icon-s-data"></i> 潞安化工2026 年招聘考试成绩查询</div>
            <div class="gradeBody" v-if="pageState === 'loading'">
                <div class="gradeLoading">
                    <i class="el-icon-loading"></i>
                    <span>正在查询成绩，请稍候…</span>
                </div>
            </div>
            <div class="gradeBody" v-else-if="pageState === 'message'">
                <div class="gradeTips gradeTips--warn"><i class="el-icon-warning-outline"></i> {{ messageText }}</div>
                <div class="gradeForm-li" v-if="messageText === '请先报名'">
                    <el-button class="gradeForm-btn icon" @click="goRegister"><i class="el-icon-edit-outline"></i> 前往报名</el-button>
                </div>
                <div class="gradeForm-li" v-else>
                    <el-button class="gradeForm-btn icon" plain @click="autoQueryGrade"><i class="el-icon-refresh"></i> 重新查询</el-button>
                </div>
            </div>
            <div class="gradeBody gradeBody--result" v-else-if="pageState === 'result'">
                <div id="printArea">
                    <div class="gradePersonHead">
                        <div class="gradePersonHead-item">
                            <div class="tw-en">姓名</div>
                            <div class="tw-zn">{{ searchData.userName }}</div>
                        </div>
                        <div class="gradePersonHead-item gradePersonHead-item--right">
                            <div class="tw-en">身份证号</div>
                            <div class="tw-zn tw-zn--sm">{{ maskIdCard(searchData.idCard) }}</div>
                        </div>
                    </div>
                    <div
                        v-for="(item, index) in gradeRecords"
                        :key="item.ticketNumber || (item.year + '-' + item.positionName + '-' + index)"
                        class="gradeRecordBlock"
                    >
                        <div class="gradeRecordHead">
                            <p class="gradePlit">{{ item.year }}年{{ item.positionName }}考试</p>
                            <p class="gradePli">考试地点：{{ item.examLocation || '—' }}</p>
                            <p class="gradePli">成绩录入时间：{{ item.scoreInputDate || '—' }}</p>
                        </div>
                        <div class="gradeResult">
                            <div class="gradeResult-t clearfix">
                                <div class="gradeResult-tl">
                                    <div class="tw-en">报考专业</div>
                                    <div class="tw-zn tw-zn--sm">{{ item.positionName || '—' }}</div>
                                </div>
                                <div class="gradeResult-tr">
                                    <div class="tw-en">准考证号</div>
                                    <div class="tw-zn tw-zn--sm">{{ item.ticketNumber || '—' }}</div>
                                </div>
                            </div>
                            <div class="gradeResult-m">
                                <table class="gradeResult-table">
                                    <tr>
                                        <td width="45%">考试科目</td>
                                        <td width="15%">满分</td>
                                        <td width="25%">考试日期</td>
                                        <td width="15%" class="tdr">得分</td>
                                    </tr>
                                    <tr v-for="row in scheduleRows(item.schedules)" :key="row.subject">
                                        <td>{{ row.subject }}</td>
                                        <td>{{ row.fullScore }}</td>
                                        <td>{{ row.examDateText }}</td>
                                        <td class="tdr">{{ formatScore(row.score) }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="total-l">总成绩</td>
                                        <td class="total-r">{{ formatScore(item.totalScore) }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="gradeStatus clearfix">
                                <span><i class="el-icon-check"></i> 成绩有效</span>
                                <span style="float: right;">{{ item.scoreInputDate || gradeDate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="gradeBtns">
                    <el-button plain @click="autoQueryGrade"><i class="el-icon-refresh"></i> 刷新成绩</el-button>
                    <el-button type="danger" @click="getPdf"><i class="el-icon-download"></i> 下载成绩单</el-button>
                </div>
            </div>
        </div>
        <div class="pageGrade-foot">注：成绩查询系统仅在规定时间内开放。如对成绩有异议，请在查询通道开启后 3 个工作日内联系人力资源部进行复核。<br/>技术支持电话：400-180-5558</div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import Cookies from "js-cookie";
import axios from "axios";
import moment from "moment";
export default {
    name: 'PageGrade',
    data() {
        return {
            searchData: {
                userName: '',
                idCard: '',
            },
            pageState: 'loading',
            messageText: '',
            gradeRecords: [],
            gradeDate: moment(new Date()).format('yyyy-MM-DD'),
        }
    },
    mounted() {
        document.title = '潞安招聘-成绩查询';
        this.autoQueryGrade();
    },
    methods: {
        goRegister() {
            this.$router.push('/pageRegLink');
        },
        maskIdCard(idCard) {
            const value = (idCard || '').trim();
            if (value.length <= 8) {
                return value;
            }
            return value.slice(0, 4) + '********' + value.slice(-4);
        },
        formatScore(score) {
            if (score === null || score === undefined || score === -1 || score === '-1') {
                return '—';
            }
            return score;
        },
        formatDateText(value) {
            if (!value) {
                return '—';
            }
            const text = moment(value);
            return text.isValid() ? text.format('YYYY-MM-DD') : String(value);
        },
        scheduleRows(schedules) {
            if (!schedules || typeof schedules !== 'object') {
                return [];
            }
            return Object.keys(schedules).map((subject) => {
                const item = schedules[subject] || {};
                return {
                    subject,
                    fullScore: item.singleScore != null ? item.singleScore : 100,
                    examDateText: this.formatDateText(item.examDate),
                    score: item.score,
                };
            });
        },
        normalizeGradeRecords(records) {
            return (records || []).map((item) => {
                const normalized = Object.assign({}, item);
                normalized.scoreInputDate = this.formatDateText(item.scoreInputDate);
                if (!normalized.year) {
                    const firstRow = this.scheduleRows(item.schedules)[0];
                    normalized.year = firstRow && firstRow.examDateText !== '—'
                        ? moment(firstRow.examDateText).format('YYYY')
                        : moment().format('YYYY');
                }
                return normalized;
            });
        },
        isScorePublished(record) {
            if (!record) {
                return false;
            }
            if (record.scoreInputDate && record.scoreInputDate !== '—') {
                return true;
            }
            const totalScore = record.totalScore;
            return totalScore != null && totalScore !== -1 && totalScore !== '-1';
        },
        getPdf () {
            const contentDom = document.getElementById('printArea');
            if (!contentDom) {
                return;
            }
            html2canvas(contentDom).then(canvas => {
                const imgData = canvas.toDataURL('image/png', 3.0);
                const pdf = new jsPDF({
                    orientation: 'portrait',
                    unit: 'px',
                    format: 'a4'
                });
                const lefMargin = (canvas.width - pdf.internal.pageSize.width) / 2;
                pdf.addImage(imgData, 'PNG', lefMargin, 100);
                const safeName = (this.searchData.userName || '考生').replace(/[\\/:*?"<>|]/g, '_');
                pdf.save(`${safeName}-成绩单.pdf`);
            });
        },
        fetchCurrentApplication() {
            return axios.get('/zhaopinapi/job-applications/currently', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const data = res.data;
                if (data && data.success && data.data) {
                    return data.data;
                }
                return null;
            }).catch(() => null);
        },
        fetchScores(userName, idCard, positionId) {
            const requestConfig = {
                params: {
                    userName,
                    idCard,
                },
                headers: { Authorization: Cookies.get('reqToKen') },
            };
            if (positionId != null && positionId !== '') {
                requestConfig.params.positionId = positionId;
            }
            return axios.get('/zhaopinapi/scores/nameCardTicket', requestConfig).then((res) => {
                const data = res.data;
                if (data && (data.success === true || data.code === 200) && data.data) {
                    return data.data.records || [];
                }
                return [];
            }).catch(() => []);
        },
        autoQueryGrade() {
            if (!Cookies.get('reqToKen')) {
                this.$router.push('/pageIndex');
                return;
            }
            this.pageState = 'loading';
            this.messageText = '';
            this.gradeRecords = [];
            this.fetchCurrentApplication().then((application) => {
                if (!application || !application.id) {
                    this.pageState = 'message';
                    this.messageText = '请先报名';
                    return null;
                }
                const userName = (application.name || '').trim();
                const idCard = (application.id_card_number || application.idCardNumber || '').trim();
                const positionId = application.position_id != null ? application.position_id : application.positionId;
                if (!userName || !idCard) {
                    this.pageState = 'message';
                    this.messageText = '请先报名';
                    return null;
                }
                this.searchData.userName = userName;
                this.searchData.idCard = idCard;
                return this.fetchScores(userName, idCard, positionId);
            }).then((records) => {
                if (records === null) {
                    return;
                }
                const publishedRecords = this.normalizeGradeRecords(records).filter((item) => this.isScorePublished(item));
                if (!publishedRecords.length) {
                    this.pageState = 'message';
                    this.messageText = '成绩暂未公布';
                    return;
                }
                this.gradeRecords = publishedRecords;
                this.pageState = 'result';
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message)
                    || '查询失败，请稍后重试';
                this.pageState = 'message';
                this.messageText = msg;
                console.log(error);
            });
        },
    }
}
</script>

<style scoped>
    .gradeContent{width: 210mm; margin: 0 auto; padding: 40px 0;}
    .gradeMain{border-radius: 10px; border: 1px solid #E5E7EB; background: #FFF; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);}
    .gradeTle{height: 40px; line-height: 40px; font-size: 18px; padding: 10px 24px; background: #E7000B; color: #fff; border-top-left-radius: 10px; border-top-right-radius: 10px;}
    .gradeBody{padding: 32px 120px;}
    .gradeBody--result{padding-bottom: 0;}
    .gradeLoading{display: flex; align-items: center; justify-content: center; gap: 10px; min-height: 180px; color: #4A5565; font-size: 16px;}
    .gradeTips{border-radius: 4px; padding: 16px; border: 1px solid #DBEAFE; background: #EFF6FF; color: #193CB8; font-size: 14px; line-height: 24px; text-align: center;}
    .gradeTips--warn{border-color: #FDE68A; background: #FFFBEB; color: #92400E;}
    .gradeForm-li{padding-top: 24px;}
    .gradeForm-li-t{line-height: 24px;}
    .gradeForm{color: #4A5565; font-size: 16px; font-weight: 600; line-height: 24px;}
    .gradeForm-btn{border-radius: 10px; display: block; cursor: pointer; width: 100%; background-color: #E7000B; color: #fff; text-align: center; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10); font-size: 16px; font-weight: bold; border: none; height: 50px; line-height: 30px; padding: 10px;}
    .gradeForm-btn:hover{background: #C10007; color: #fff;}
    .pageGrade-foot{padding-top: 40px; font-size: 12px; color: #99A1AF; text-align: center; line-height: 24px;}
    .gradePersonHead{display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 24px; padding: 16px 18px; border-radius: 10px; background: #F9FAFB; border: 1px solid #E5E7EB;}
    .gradePersonHead-item--right{text-align: right;}
    .gradeRecordBlock + .gradeRecordBlock{margin-top: 28px; padding-top: 28px; border-top: 1px dashed #D1D5DC;}
    .gradeRecordHead{margin-bottom: 16px;}
    .gradeResult{border-radius: 10px; border: 2px solid #1E2939; background: #FFF; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10);}
    .gradeResult-t{border-bottom: 1px solid #E5E7EB; background: #F9FAFB; padding: 16px; border-top-right-radius: 10px; border-top-left-radius: 10px;}
    .gradeResult-tl{float: left; max-width: 58%;}
    .gradeResult-tr{float: right; text-align: right; max-width: 40%;}
    .tw-en{font-size: 12px; line-height: 20px; font-weight: bold; color: #6A7282;}
    .tw-zn{font-size: 18px; line-height: 24px; font-weight: bold; color: #101828; word-break: break-all;}
    .tw-zn--sm{font-size: 15px;}
    .gradeResult-m{padding: 24px; background-color: #fff;}
    .gradeResult-table{width: 100%; border: none; border-collapse: collapse; border-spacing: 0;}
    .gradeResult-table td{padding: 10px 0; line-height: 28px; border-bottom: 1px solid #F3F4F6; background-color: #fff;}
    .gradeResult-table td.tdr{text-align: right;}
    .gradeResult-table td.total-l{background-color: #FEF2F2; color: #9F0712; font-size: 16px; padding-left: 16px; font-weight: bold;}
    .gradeResult-table td.total-r{background-color: #FEF2F2; color: #E7000B; font-size: 30px; text-align: right; padding-right: 16px; font-weight: bold;}
    .gradeStatus{background: #1E2939; color: #fff; padding: 10px 16px; line-height: 28px; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;}
    .gradeBtns{padding-top: 24px; text-align: center;}
    .gradePlit{font-size: 22px; font-weight: bold; text-align: center; margin: 0 0 8px;}
    .gradePli{font-size: 16px; margin: 4px 0;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
